import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "field w-full" }

import { useOrganizationIntegrationStore } from '@/store';
import { OrganizationIntegrationCustomerInterface } from '@/types/OrganizationInterface';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { storeToRefs } from 'pinia';
import { useToast } from 'primevue/usetoast';
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationIntegrations',
  setup(__props) {

const organizationIntegrationStore = useOrganizationIntegrationStore();
const { error, message } = storeToRefs(organizationIntegrationStore);
const route = useRoute();
const orgId = ref<number>();
const rules = computed(() => {
  return { required };
});

const selectedCustomer = ref();
const toast = useToast();

const v$ = useVuelidate(rules, selectedCustomer);

onMounted(() => {
  init();
});

const init = async () => {
  orgId.value = parseInt(route.params.id as string);
  await organizationIntegrationStore.getIntegrationCustomers();
  await organizationIntegrationStore.getOrganizationIntegrationCustomer(orgId.value);
  if (organizationIntegrationStore.integrationCustomer)
    selectedCustomer.value = organizationIntegrationStore.integrationCustomer.id;
};

const onCancel = () => {
  resetDirty();
  selectedCustomer.value = null;
};

const onSave = async () => {
  if (selectedCustomer.value && orgId.value) {
    const payload: OrganizationIntegrationCustomerInterface = {
      organization_id: orgId.value,
      quickbooks_customer_id: selectedCustomer.value,
    };

    await organizationIntegrationStore.saveOrganizationIntegrationCustomer(payload);
    doToast();
    resetDirty();
  }
};

/**
 * reset the form dirty settting
 * which hides the footer buttons and style
 */
const resetDirty = () => {
  v$.value.$reset();
};

/**
 * Display the toast message.
 */
const doToast = () => {
  toast.add({
    severity: error.value ? 'error' : 'success',
    summary: error.value ? 'Error' : 'Saved',
    detail: message,
    life: 3000,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_FormCard = _resolveComponent("FormCard")!

  return (_openBlock(), _createBlock(_component_FormCard, {
    title: "Quickbooks",
    dirty: _unref(v$).$anyDirty,
    cancel: onCancel,
    save: onSave,
    "save-disabled": _unref(v$).$invalid && _unref(v$).$dirty
  }, {
    form: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("label", {
            class: "font-bold",
            for: "customer_list"
          }, "Customer", -1)),
          (_unref(organizationIntegrationStore).loading)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                height: "2.3rem",
                class: "w-full"
              }))
            : (_openBlock(), _createBlock(_component_Dropdown, {
                key: 1,
                id: "customer_list",
                modelValue: selectedCustomer.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCustomer).value = $event)),
                options: _unref(organizationIntegrationStore).customers,
                "option-label": "customer_name",
                "option-value": "id",
                placeholder: "Select a Customer",
                onChange: _unref(v$).$touch
              }, null, 8, ["modelValue", "options", "onChange"]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["dirty", "save-disabled"]))
}
}

})